import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useContainerHeight } from '@/common/hooks/useContainerHeight';

interface EmbedViewerProps {
  url: string;
  onEdit: () => void;
}

export const EmbedViewer = ({ url, onEdit }: EmbedViewerProps) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const containerHeight = useContainerHeight(containerRef);

  return (
    <div ref={containerRef} className="h-full w-full relative group">
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          className="w-full h-full"
          src={url}
          style={{
            border: 0,
            height: Math.max(containerHeight, 500), // Minimum height of 200px
          }}
          allowFullScreen
        />

      <button
        className="absolute top-2 right-2 px-3 py-1.5 text-sm bg-white/90 hover:bg-white rounded-lg shadow-sm transition-colors opacity-0 group-hover:opacity-100 flex items-center gap-2"
        onClick={onEdit}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        </svg>
        {t('embed.edit')}
      </button>
    </div>
  );
}
